module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo01-miniaturka-fbbfe9500aba79bfba63a1dbecd66fa4.jpg";